import request from '@/utils/request';

// 查询累计用户总数、最近一天新增用户总数、最近7天新增用户总数、最近30天新增用户总数
export async function selStatMemberLastSomeDay(params) {
  return request.post('/api/stat/statMemberIndicateVal/selStatMemberLastSomeDay', { ...params });
}
// 按用户类型分类查询用户数
export async function selStatMemberByUserType(params) {
  return request.post('/api/stat/statMemberIndicateVal/selStatMemberByUserType', { ...params });
}

// 查询按日期统计用户数据指标
export async function selStatMember(params) {
  return request.post('/api/stat/statMemberDate/selStatMember', { ...params });
}

// 查询用户活跃地区排行榜
export async function selStatMemberArea(params) {
  return request.post('/api/stat/statMemberArea/selStatMemberArea', { ...params });
}

// TOP10门店订货排行榜
export async function selCustomerMoney(params) {
  return request.post('/api/stat/statMemberCustomer/selCustomerMoney', { ...params });
}

// 用户分布
export async function selUserDataInfo(params) {
  return request.post('/api/bigdata/stat/selUserDataInfo', { ...params });
}

